<div *ngIf="title" class="row no-gutters mb-4">
  <div class="col-sm-12 smp-title">{{ title }}</div>
</div>

<div class="row checkbox-row no-gutters" *ngFor="let checkboxRow of checkBoxRows">
  <ng-container *ngFor="let selection of checkboxRow; let idx = index">
    <div class="checkbox-container {{ activeCheckboxRowConfig.col }}"
         [ngClass]="{ firstOfRow: idx === 0, lastOfRow: idx === (activeCheckboxRowConfig.amount - 1) }"
         *ngIf="selection.display">
      <dr-checkbox [idPrefix]="idPrefix"
                   [idSuffix]="selection.key"
                   [boolValue]="selection.selected"
                   [patchPath]="selection.key"
                   [label]="selection.trans"
                   [disabled]="selection.disabled || disabled"
                   (updated)="toggleSelect($event)">
      </dr-checkbox>
    </div>
  </ng-container>
</div>
